import { takeLeading, call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import momentTZ from 'moment-timezone';
import api from 'services/api';
import classesActions from './actions';
import errorActions from '../error/actions';
import dxApi from 'services/dxApi';

const {
  Types: {
    LOAD_CLASSES_SCHEDULE_REQUEST,
    LOAD_GUEST_CLASSES_SCHEDULE_REQUEST,
    LOAD_FAVORITE_CLASSES_REQUEST,
    ADD_CLASS_TO_FAVORITE_REQUEST,
    REMOVE_CLASS_FROM_FAVORITE_REQUEST,
    LOAD_OPEN_CLASSES_REQUEST,
    LOAD_OPEN_CENTERS_REQUEST,
  },
  Creators: {
    loadClassesScheduleSuccess,
    loadClassesScheduleFailure,

    loadGuestClassesScheduleSuccess,
    loadGuestClassesScheduleFailure,

    loadFavoriteClassesSuccess,
    loadFavoriteClassesFailure,

    addClassToFavoriteSuccess,
    addClassToFavoriteFailure,

    removeClassFromFavoriteSuccess,
    removeClassFromFavoriteFailure,

    loadOpenClassesSuccess,
    loadOpenClassesFailure,
    loadOpenCentersSuccess,
    loadOpenCentersFailure,
  },
} = classesActions;

const {
  Creators: { setError },
} = errorActions;

function* loadClasses({ payload }) {
  const { startDate, clubId } = payload;

  try {
    const { data } = yield call(
      dxApi.get,
      `/class/classes-nv2?clubId=${clubId}&startDate=${startDate}`
    );

    yield put(loadClassesScheduleSuccess({ classes: data.data, clubId }));
  } catch (error) {
    yield put(loadClassesScheduleFailure(error));
    yield put(setError('Failed to load Classes.'));
  }
}

function* loadGuestClasses({ payload }) {
  const { startDate, clubId } = payload;
  try {
    const { data } = yield call(
      dxApi.get,
      `/class/guest-classes-nv2?clubId=${clubId}&startDate=${startDate}`
    );
    yield put(loadGuestClassesScheduleSuccess({ classes: data.data, clubId }));
  } catch (error) {
    yield put(loadGuestClassesScheduleFailure(error));
    yield put(setError('Failed to load Classes.'));
  }
}

function* loadOpenClasses() {
  const fromDate = momentTZ.tz('America/Los_Angeles').format('YYYY-MM-DD');
  const toDate = momentTZ.tz('America/Los_Angeles').add(13, 'days').format('YYYY-MM-DD'); // TEMP: testing only, revert to 14

  try {
    const { data } = yield call(() =>
      axios.get(`${process.env.REACT_APP_OPEN_CLASSES_BASE_URL}/api/v1/bookings/open/classes`, {
        params: { fromDate, toDate },
        headers: { 'X-api-key': process.env.REACT_APP_OPEN_CLASSES_API_KEY },
      })
    );

    const classes = (data.data || []).map(item => ({
      classId: `${item.centerId}-${item.date}-${item.startTime}-${item.name}`,
      centerId: item.centerId,
      classInfo: {
        name: item.name,
        programName: item.name,
        club: { name: item.centersName },
      },
      startTime: item.startTime,
      endTime: item.endTime,
      date: item.date,
      trainerName: item.instructors?.[0]?.name?.full || '',
      isLive: false,
      isVirtual: false,
      studioName: item.roomNames?.[0] || '',
      description: item.description || '',
      classImage: item.classImage || '',
    }));

    yield put(loadOpenClassesSuccess({ classes }));
  } catch (error) {
    yield put(loadOpenClassesFailure(error));
    yield put(setError('Failed to load Classes.'));
  }
}

function* loadOpenCenters() {
  try {
    const { data } = yield call(() =>
      axios.get(`${process.env.REACT_APP_OPEN_CLASSES_BASE_URL}/api/v1/centers`, {
        headers: {
          accept: 'application/json',
          'X-api-key': process.env.REACT_APP_OPEN_CLASSES_API_KEY,
        },
      })
    );
    yield put(loadOpenCentersSuccess({ centers: data.data || [] }));
  } catch (error) {
    yield put(loadOpenCentersFailure(error));
    yield put(setError('Failed to load Centers.'));
  }
}
function* loadFavoritesClasses({ payload }) {
  const { startDate, clubId } = payload;

  try {
    const { data } = yield call(
      api.get,
      `/classes/favorites?startDate=${startDate}&clubId=${clubId}`
    );
    yield put(loadFavoriteClassesSuccess(data));
  } catch (error) {
    yield put(loadFavoriteClassesFailure(error));
    yield put(setError('Failed to load favorite classes.'));
  }
}

function* addClassToFavorite({ classId }) {
  try {
    const { data } = yield call(api.post, `/classes/addToFavorites?classId=${classId}`);
    yield put(addClassToFavoriteSuccess(data));
  } catch (error) {
    yield put(addClassToFavoriteFailure(error));
    yield put(setError('Failed to add to favorite.'));
  }
}

function* removeClassFromFavorite({ classId }) {
  try {
    const { data } = yield call(
      api.remove,
      `/classes/removeFromFavorites?classId=${classId}`
    );
    yield put(removeClassFromFavoriteSuccess(data));
  } catch (error) {
    yield put(removeClassFromFavoriteFailure(error));
    yield put(setError('Failed to remove from favorite.'));
  }
}

export function* classesScheduleSaga() {
  yield takeLatest(LOAD_CLASSES_SCHEDULE_REQUEST, loadClasses);
  yield takeLatest(LOAD_GUEST_CLASSES_SCHEDULE_REQUEST, loadGuestClasses);
  yield takeLatest(LOAD_OPEN_CLASSES_REQUEST, loadOpenClasses);
  yield takeLatest(LOAD_OPEN_CENTERS_REQUEST, loadOpenCenters);
  yield takeLeading(LOAD_FAVORITE_CLASSES_REQUEST, loadFavoritesClasses);
  yield takeLeading(ADD_CLASS_TO_FAVORITE_REQUEST, addClassToFavorite);
  yield takeLeading(REMOVE_CLASS_FROM_FAVORITE_REQUEST, removeClassFromFavorite);
}
